import parseDialogue from "../../util/parseDialogue";

export const MinervaRevisit = parseDialogue(`
minerva:revisit:100-200

#100 I know you'd be back - glad to see your energy is still flowing. I have that software you've been dreaming about. Are you ready to enter the magic circle?
>200 Show me what you've got.
>0 No thanks.
`);
